// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__NoOdZ","dashboardBody":"Dashboard_dashboardBody__bD+D0"};